export const NUM_STORIES_REGION_SWIMLANE = 4;
